// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OrderOfferTemplate from 'components/order/OrderOfferTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrdersActions } from '../../store/actionCreators';

type Props = {
  order: any,
  user: any,
  logged: boolean,
};

class OrderOfferTemplateContainer extends Component<Props> {
  initialize = async () => {
    try {
      const { orderId } = this.props.match.params;
      if (!this.props.logged) await OrdersActions.authenticate(orderId);
      await OrdersActions.getOrder(orderId);
      let history1 = this.props.history;
      setTimeout(() => {
        window.print();
        history1.goBack()
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    if(this.props.loading === undefined || this.props.loading) return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <OrderOfferTemplate
        order={this.props.order}
        user={this.props.user}
        logged={this.props.logged}
      />
    );
  }
}

export default connect(
  ({ orders, user, pender }: State) => ({
    order: orders && orders.order,
    user: user.user,
    logged: !!user.user,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(OrderOfferTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/order/OrderOfferTemplateContainer.js